// @flow

import * as React from 'react';

import styles from './SearchInstructions.scss';

export type Props = {|
  resultsFound: boolean
|};

function InstructionsHeader(resultsFound: boolean) {
  return resultsFound
    ? __('search.search_instructions.header.results_found')
    : __('search.search_instructions.header.results_not_found');
}

export default function SearchInstructions(props: Props) {
  return (
    <section className={styles.container}>
      <hgroup>
        <h5>{InstructionsHeader(props.resultsFound)}</h5>
        <h6 className={styles.subheader}>
          {__('search.search_instructions.subheader')}
        </h6>
      </hgroup>
    </section>
  );
}
